import React, { useState } from "react";
import { useSpring, animated, config } from "react-spring";
import { scroller } from "react-scroll";
import IntersectionObserverWrapper from "../../../components/intersection-observer-wrapper/IntersectionObserverWrapper";
import DevHeroImage from "../../../components/layouts/hero-image/DevHeroImage";
import Section from "../../../components/layouts/section/Section";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

type Props = {};

function DevHeroImageSection({}: Props) {
  const [isVisible, setIsVisible] = useState(false);
  const anim = useSpring({
    from: {
      opacity: 0,
      x: -200,
    },
    to: {
      opacity: 1,
      x: 0,
    },
    config: config.default,
  });

  const anim2 = useSpring({
    from: {
      opacity: 0,
      x: -200,
    },
    to: {
      opacity: 1,
      x: 0,
    },
    config: config.default,
    delay: 300,
  });

  const anim3 = useSpring({
    from: {
      opacity: 0,
      x: -200,
    },
    to: {
      opacity: 1,
      x: 0,
    },
    config: config.default,
    delay: 600,
  });

  const anim4 = useSpring({
    from: {
      x: 100,
      opacity: 0,
    },
    to: {
      x: 0,
      opacity: 1,
    },
    config: config.default,
    delay: 1200,
  });

  const handleChange = (visible: boolean) => {
    if (visible) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const handleButtonClick = () => {
    scroller.scrollTo("waitlist", {
      duration: 1000,
      delay: 0,
      smooth: true,
      offset: 100,
    });
  };

  return (
    <IntersectionObserverWrapper onChange={handleChange}>
  <Section >
    <DevHeroImage
      vidSrc={"/static/hero-images/dev2.mp4"}
      imgSrc={"/static/hero-images/dev.webp"}
    />
    <div className="absolute w-full h-full overflow-hidden">
      <div
        className="
          relative flex flex-col items-center justify-center 
          w-full left-6 top-[60%] gap-2 
          text-shadow-md lg:px-[100px]
        "
      >

        {/* Title */}
        <animated.h1
          style={anim2}
          className="text-white text-4xl md:text-[56px] font-bold leading-tight !text-center opacity-0 animate-fade-in [animation-delay:300ms]"
        >
          Transform Fragmented Gaming Data Into a  Unified Intelligence Platform
        </animated.h1>

        {/* Subtitle */}
        <animated.h4 style={anim3} className="text-base md:text-lg text-white !text-center opacity-0 animate-fade-in [animation-delay:500ms]">
        Reveal the complete story behind every player interaction. Track user journeys across hardware, friendships, and gameplay patterns while empowering your QA team with environmental transparency that turns every bug into actionable insights.
        </animated.h4>

        {/* Button */}
        <animated.div style={anim4}>
        <Button
            variant="contained"
            size="large"
            endIcon={
              <FontAwesomeIcon icon={faCaretRight} height={8} width={6} />
            }
            onClick={handleButtonClick}
            className="
              cursor-pointer rounded-lg border-none bg-[#fff] !mt-8
              px-6 py-3 text-white font-medium shadow-md hover:bg-[#00DDDD]
            "
          >
            Sign up now
          </Button>
        </animated.div>
      </div>
    </div>
  </Section>
</IntersectionObserverWrapper>

  );
}

export default DevHeroImageSection;
